<div>
  @if (isButtonDetailsVisible()) {
    <pas-button-round
      [color]="pasButtonRoundColor.DARK"
      (click)="onClick($event)"
      icon="search"
      size="small"></pas-button-round>
  }
</div>
